import React from "react"

function NorthDakota() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="89" height="80" viewBox="0 0 89 80">
            <path d="M84.48 56.32l-0.72-5.76-2.32-4.88 0.16-4.4-0.8-1.040-0.8-9.36-3.040-8.080-0.64-6.16 0.4-1.68-1.36-5.36-34.96 0.8-34.32-0.96-2.080 47.040 40.4 0.96z"></path>
        </svg>
    )
}

export default NorthDakota

